import { render, staticRenderFns } from "./ManageSources.vue?vue&type=template&id=44d71e36&lang=html&"
import script from "./ManageSources.vue?vue&type=script&lang=js&"
export * from "./ManageSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports